import { render, staticRenderFns } from "./ProductsStart.vue?vue&type=template&id=1cff918a&"
import script from "./ProductsStart.vue?vue&type=script&lang=ts&"
export * from "./ProductsStart.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsStart.vue?vue&type=style&index=0&id=1cff918a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports